// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3237":"5f6e0032","3572":"82167394","3822":"a0b94047","5363":"46eb218c","8654":"82167394"}[chunkId] + ".chunk.css";
};